import React, { useCallback, useMemo, useState } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { Box } from "@mui/material"
import {
	PSE_STATUS,
	showProductionStepsSupervision,
	updateProductionStepExecutionComments
} from "../../actions/ProductionSteps/ProductionStepExecutions"
import {
	getAllPSECommentsExecutionSelector,
	getProductionStepExecutionSelector
} from "../../reducers/Production/ProductionSteps"
import ProductionStepExecutionTodo from "./ProductionStepExecutionTodo"
import ProductionStepExecutionInProgress from "./ProductionStepExecutionInProgress"
import ProductionStepExecutionToTest from "./ProductionStepExecutionToTest"
import ProductionStepExecutionDone from "./ProductionStepExecutionDone"
import CommentsDrawer from "../../components/Comments/CommentsDrawer"
import ProductionStepsExecutionFixedHeader from "./ProductionSteoExecutionsFixedHeader"
import { showAlerts } from "../../actions/ProductionSteps/alerts"
import dayjs from "dayjs"
import PSEHeaderResume from "./preview/PSEHeaderResume"
import PrintPSE from "./print/PrintPSE"

const sx = {
	body: {
		padding: "64px 0 24px 0",
		display: "flex",
		flexDirection: "column",
		gap: "24px"
	}
}
const ProductionStepExecution = (props) => {
	const dispatch = useDispatch()
	const productionStepExecution = useSelector(getProductionStepExecutionSelector)
	const pseComments = useSelector(getAllPSECommentsExecutionSelector)
	const userId = useSelector(state => state.app.user.id)
	const [commentsDrawerShown, setCommentsDrawerShown] = useState(false)

	const handleShowComments = () => setCommentsDrawerShown(true)

	const handleCommentEdit = useCallback((newComment) => {
		const currentComments = productionStepExecution.comments || []
		currentComments.push(newComment)
		dispatch(updateProductionStepExecutionComments(productionStepExecution.objectId, currentComments))
	}, [productionStepExecution])

	const status = useMemo(() => productionStepExecution?.status, [productionStepExecution])
	const isFromAlertsPage = useMemo(() => props?.location?.query.from === "alerts", [props?.location?.query])

	const handleBack = () => {
		if (!productionStepExecution) return
		const status = productionStepExecution.status
		if (status === PSE_STATUS.done) {
			if (isFromAlertsPage) {
				dispatch(showAlerts(dayjs(productionStepExecution.stepProductionDate).format("DD-MM-YYYY")))
				return
			}
			dispatch(showProductionStepsSupervision())
			return
		}

		dispatch(showProductionStepsSupervision())
	}

	const getContent = useCallback(() => {
		if ([PSE_STATUS.locked, PSE_STATUS.todo].includes(status)) {
			return (
				<ProductionStepExecutionTodo
					productionStepExecution={productionStepExecution}
					onClickCommentsIcon={handleShowComments}
					commentsCount={(pseComments || []).length}
				/>
			)
		}
		if (status === PSE_STATUS.inProgress) {
			return (
				<ProductionStepExecutionInProgress
					productionStepExecution={productionStepExecution}
					onClickCommentsIcon={handleShowComments}
					commentsCount={(pseComments || []).length}
					userId={userId}
				/>
			)
		}
		if (status === PSE_STATUS.toTest) {
			return (
				<ProductionStepExecutionToTest
					productionStepExecution={productionStepExecution}
					onClickCommentsIcon={handleShowComments}
					commentsCount={(pseComments || []).length}
				/>
			)
		}
		if (status === PSE_STATUS.done) {
			return (
				<ProductionStepExecutionDone
					productionStepExecution={productionStepExecution}
					isFromAlertsPage={isFromAlertsPage}
					onGoBack={handleBack}
				/>
			)
		}
	}, [productionStepExecution, status])

	return (
		<Box sx={{ paddingBottom: "86px" }}>
			{/* header */}
			<ProductionStepsExecutionFixedHeader onBack={handleBack} />
			<Box sx={sx.body}>
				<PSEHeaderResume
					productionStepExecution={productionStepExecution}
					onClickComments={handleShowComments}
					commentsCount={(pseComments || []).length}
					renderPrint={() => <PrintPSE pse={productionStepExecution} />}
					style={{ margin: "24px 24px 0 24px" }}
				/>
				{getContent()}
			</Box>
			<CommentsDrawer
				comments={pseComments}
				open={commentsDrawerShown}
				onAddComment={handleCommentEdit}
				onClose={() => setCommentsDrawerShown(false)}
			/>
		</Box>
	)
}

export default ProductionStepExecution